import { queryClient } from '@/adapters/query';
import { ScreenerSettingName } from '@/pages/CRM/Screener/hooks/useScreenerSettingsQuery';
import type { GetFacilitySettings200Response } from '@/types/crm-screener-api';

const FACILITY_SETTINGS_QUERY_KEY = 'screenerFacilitySettings';

const readSettings = (
  facilityId: string
): Record<string, string | number | undefined> | undefined => {
  const data = queryClient.getQueryData<GetFacilitySettings200Response['data']>(
    [FACILITY_SETTINGS_QUERY_KEY, facilityId]
  );
  return data?.settings as
    | Record<string, string | number | undefined>
    | undefined;
};

export const isScreenerSettingEnabled = (
  settingName: ScreenerSettingName,
  facilityId: string
): boolean => {
  return readSettings(facilityId)?.[settingName] === 'enabled';
};

export const getScreenerSettingValue = (
  settingName: ScreenerSettingName,
  facilityId: string
): string | undefined => {
  const value = readSettings(facilityId)?.[settingName];
  return typeof value === 'string' ? value : undefined;
};
